// filepath: src/components/date-picker/index.tsx
import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Label, StyledDatePicker, Wrapper } from "./styles";

interface DatePickerProps {
  label: string;
  value: Dayjs | null;
  onChange: (newValue: Dayjs | null) => void;
}

export const CustomDatePicker: React.FC<DatePickerProps> = ({
  label,
  value,
  onChange,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <Wrapper>
        <Label>{label}</Label>
        <StyledDatePicker
          value={value}
          onChange={onChange}
          format="DD/MM/YY"
          slots={{
            openPickerIcon: CalendarTodayIcon,
          }}
          slotProps={{
            textField: {
              placeholder: "dd/mm/aa",
            },
          }}
        />
      </Wrapper>
    </LocalizationProvider>
  );
};